var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cgateways-list ng-if=\"$ctrl.loaded\" gateways=\"$ctrl.gateways\" query=\"$ctrl.query\" on-refresh=\"$ctrl.fetchGateways()\"\u003E\u003C\u002Fgateways-list\u003E";;return pug_html;};
module.exports = template;